import { ExpressBroadcastCardContextProvider } from './ExpressBroadcastCard.context'
import { ExpressBroadcastCardController } from './ExpressBroadcastCard.controller'
import { FC } from 'react'

/** Admin view of an express order's wait for a creative, with a way to stop its broadcast */
export const ExpressBroadcastCard: FC = () => {
  return (
    <ExpressBroadcastCardContextProvider>
      <ExpressBroadcastCardController />
    </ExpressBroadcastCardContextProvider>
  )
}
